import {inject, Injectable} from "@angular/core";
import {
    ActionService,
    ConfigurationService,
    EntityData,
    field,
    JwtHttpClientService,
    ResourceModule
} from "@fedelta-pos/data-client";

export class OrderPostscriptData extends EntityData<OrderPostscriptData> {
    @field requestId: string;
    @field appUserId: string;
    @field email: string;
    @field mobilePhone: string;
    @field postCode: string;
    @field marketingOptIn: boolean;
}

@Injectable({providedIn: "root"})
export class OrderPostscriptService extends ActionService {
    constructor() {
        const http: JwtHttpClientService = inject(JwtHttpClientService);
        const configService: ConfigurationService = inject(ConfigurationService);
        const nameSpace: string = inject<string>(ResourceModule.RESOURCE_NAMESPACE_KEY);
        const actionNames: string[] = inject<string[]>(ResourceModule.ACTION_NAMES_KEY);
        const useAsync: boolean = inject<boolean>(ResourceModule.RESOURCE_USE_ASYNC);

        console.log("--- OrderPostscriptService");

        super(http, nameSpace, "app-order-postscript", configService, useAsync, actionNames);
    }
}
